export enum Step {
  RATE_WORDCLOUD,
  RATE_RESPONSES,
}
